import React, { useContext, useEffect } from 'react';
import Modal from '../components/Shell/Modal';
import useModal from '../hooks/useModal';
import { capitalizeFirstLetter } from '../components/helpers/functions';
import SettingsContext from '../context/SettingsContext';
import { Spinner } from '../components/Form';
import {
	TemplateBoolean,
	TemplateDropdown,
	TemplateReactSelect,
} from '../components/Attributes/Attributes_old';
import useAsync from '../hooks/useAsync';
import { getModuleFields } from '../api/modules';
import useSettings from '../hooks/useSettings';
import usePrevious from '../hooks/usePrevious';
import SimpleDNDList from '../components/SimpleDNDList';

const MODAL_NAME = 'manageColumns';
const ASSETS_MODULE_ID = process.env.REACT_APP_MODULE_ID_ASSETS;

export default () => {
	const { open: options, setClose } = useModal(MODAL_NAME);

	const { get: getSetting, set: setSetting } = useSettings();

	const {
		settings,
		loading: isLoadingSettings,
		refresh: refreshSettings,
		update: updateSettings,
	} = useContext(SettingsContext);

	const {
		value: moduleFields,
		execute: onRefreshModuleFields,
		status,
	} = useAsync(getModuleFields, {
		immediate: false,
	});

	const prevOpen = usePrevious(options);
	useEffect(() => {
		if (options && !prevOpen) {
			onRefreshModuleFields({ id: ASSETS_MODULE_ID });
		}
	}, [options]);

	const MAIN_COLUMN_OPTIONS = [
		{ label: 'Manufacturer', value: 'default' },
		...(moduleFields?.length
			? moduleFields
					?.filter((attr) => ['manufacturer', 'model'].indexOf(attr?.key) < 0)
					.map((attr) => ({
						value: attr?.isDefault ? attr?.key : attr.id,
						label: attr.label,
					}))
			: []),
	];

	const assetMainColumn = getSetting('assetMainColumn');

	return (
		<Modal
			title={
				<div className="flex items-center">
					Manage Columns{' '}
					{isLoadingSettings && status === 'pending' && (
						<Spinner className="ml-2" />
					)}
				</div>
			}
			open={!!options}
			onClose={() => setClose()}
		>
			<div className="grid grid-cols-12 gap-x-3 gap-y-4">
				<div className="col-span-4 flex items-center">
					<div className="min-w-0 flex items-center text-sm leading-6">
						<label className="select-none text-xs text-gray-900">
							Pinned Column
						</label>
					</div>
				</div>
				<div className="col-span-8">
					<TemplateDropdown
						className={'w-72'}
						options={MAIN_COLUMN_OPTIONS}
						value={assetMainColumn?.value || 'default'}
						onChange={(index, value, raw) => {
							if (value) {
								setSetting('company', 'assetMainColumn', raw, {
									showNotification: false,
								});
							} else {
								setSetting('company', 'assetMainColumn', null, {
									showNotification: false,
								});
							}
						}}
					/>
				</div>
				<div className="col-span-12">
					<div className="min-w-0 text-sm leading-6">
						<label className="select-none text-xs text-gray-900">
							Column Order
						</label>
					</div>
				</div>
				<div className="col-span-12">
					<TemplateBoolean
						name="Toggle all"
						value={options?.table?.getIsAllColumnsVisible()}
						onChange={(index, value) =>
							options?.table?.toggleAllColumnsVisible(value)
						}
					/>
					<SimpleDNDList
						items={options?.table?.getAllLeafColumns().map((column) => ({
							id: column?.id,
							value: column?.id,
							checked: column?.getIsVisible(),
							onChange: (value) => column?.toggleVisibility(value),
						}))}
						Card={({ item }) => {
							return (
								<div className="rounded-lg mb-3 px-6 py-4 border border-gray-200 px-6 flex justify-between">
									<div>{item?.value}</div>
									<div>
										<TemplateBoolean
											value={item?.checked}
											onChange={(index, value) => item?.onChange(value)}
										/>
									</div>
								</div>
							);
						}}
						onChange={(newList) => console.log('cards new list: ', newList)}
					/>
				</div>
			</div>
		</Modal>
	);
};
